import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChatUser, Messages, SaveSendMessage } from '../models/chatBox.model';

@Injectable({
  providedIn: 'root'
})
export class ChatboxService extends ServiceBase {
  public api = '/ChatBox';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  public sendMessage(gallery: Messages): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/send';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, gallery, httpOptions);
  }

  public getAllMessages(galleryId: string, artistId: string): Observable<Messages[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/messages/' + artistId + '/' + galleryId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<Messages[]>(url, httpOptions);
  }

  public getConnectedUsers(): Observable<ChatUser[]> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/chats';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ChatUser[]>(url, httpOptions);
  }

  public getMessageById(messageId: string): Observable<Messages> {
    var httpOptions = this.RequestHeaders();
    const method: string = `/${messageId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<Messages>(url, httpOptions);
  }

}
